import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import Header from './Header';
import defaultAvatarThumb from '../../images/default_dealer_thumb.png';

const HeaderContainer = ({ avatarThumb, newConversationsCount, isLoading, }) => {
  return (
    <div className="col-md-12">
      <Header
        avatarThumb={avatarThumb || defaultAvatarThumb}
        newConversationsCount={newConversationsCount}
        isLoading={isLoading}
      />
    </div>
  );
};
HeaderContainer.propTypes = {
  avatarThumb: PropTypes.string,
  newConversationsCount: PropTypes.number,
  isLoading: PropTypes.bool,
};

HeaderContainer.defaultProps = {
  avatarThumb: null,
  newConversationsCount: null,
  isLoading: false,
};

const mapStateToProps = (state) => {
  return {
    avatarThumb: get(state, ['userData', 'avatar_thumb']),
    newConversationsCount: get(state, ['conversations', 'newConversationsCount']),
    isLoading: get(state, ['loader', 'isLoading']),
  };
};

export default connect(mapStateToProps)(HeaderContainer);
